import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { UserInfo, StandardApiError } from '@tecommon/structures/structures';

@Injectable()
export class LoginUserInfoService
{
    private userInfo: UserInfo;
    private error: StandardApiError;

    constructor(private readonly http: HttpClient) { }

    public getUserInfo(): Observable<UserInfo>
    {
        var wait = new Subject<UserInfo>();
        //if (this.userInfo) {
        //    // We already have the UserInfo data, just return it right away!
        //    console.log("Look what I found!");
        //    wait.next(this.userInfo); // rxJs/Subject.next() is what signals that the Observable has completed 
        //} else {
            // We haven't already fetched the UserInfo data from the server, go get it!
            console.log("Fetching UserInfo from the server!");
            this.http.get<UserInfo>("/api/User/Info").subscribe(result=> {
                this.userInfo = result;
                wait.next(this.userInfo);
                return wait;
            });
        //}
        return wait;
    }
    
}